import { Component, OnInit, Input } from '@angular/core';
import { ProcessActivityObject, TimeStatus } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';
import { DateUtils } from 'src/app/services/utils/date.utils';

@Component({
  selector: 'app-duration-info',
  templateUrl: './duration-info.component.html',
  styleUrls: ['./duration-info.component.css'],
})
export class DurationInfoComponent implements OnInit {

  private _processActivity: ProcessActivityObject;
  @Input()
  get processActivity(): any {
    return this._processActivity;
  }
  set processActivity(value: any) {
    this._processActivity = value;
    this.ngOnInit();
  }

  progress: number;
  tooltip: string;
  tooltip2: string;
  startDate: Date;
  endDate: Date;
  actualDuration: string;

  constructor() { }

  ngOnInit() {
    this.progress = Math.round(100 * (this.processActivity.getActualDuration() / this.processActivity.getExpectedDuration()));
    this.tooltip = this.obtainTooltip();
    this.actualDuration = DateUtils.getDuration(this.processActivity.getActualDuration());

  }

  public obtainTooltip(): string {
    this.startDate = this.processActivity.getStartDate();
    const type = this.processActivity.getType() + '\n';
    const actualDuration = 'Duración actual: ' + DateUtils.getDuration(this.processActivity.getActualDuration()) + ' (' +
      parseFloat((' ' + this.processActivity.getActualDuration() * 100 / this.processActivity.getExpectedDuration())).toFixed(2)
      + '%)\n';
    const duration = 'Duración: ' + DateUtils.getDuration(this.processActivity.getActualDuration()) + ' (' +
      parseFloat((' ' + this.processActivity.getActualDuration() * 100 / this.processActivity.getExpectedDuration())).toFixed(2)
      + '%)\n';
    const expectedDuration = 'Duración esperada: ' +
      DateUtils.getDuration(this.processActivity.getExpectedDuration()) + '\n';
    const fechaInicio = 'Fecha inicio: ';

    if (this.processActivity.getTimeStatus() === TimeStatus.COMPLETED ||
      this.processActivity.getTimeStatus() === TimeStatus.COMPLETED_EXCEEDED) {
      this.tooltip2 = '\nFecha de finalización: ';
      this.endDate = this.processActivity.getCompletedDate();
    }
    return type + actualDuration + expectedDuration + fechaInicio;
  }

}
